import React from 'react';
import Text from '../../Base/Text/Text';
import { PatientCompareDataTableColumn } from '../../../Modules/Patient/Interfaces/Patient/PatientCompareDataTableColumn.interface';

interface Props {
	columns: PatientCompareDataTableColumn[];
}

const PatientProfileDataCompareTableHead = ({ columns }: Props) => {
	return (
		<thead>
			<tr>
				<th />
				{columns.map((column, index) => (
					<th key={index}>
						<Text tx={column.title} />
					</th>
				))}
			</tr>
		</thead>
	);
};

export default PatientProfileDataCompareTableHead;
